import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';
import {NgForm} from '@angular/forms';


declare var $: any;
declare var body: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-packges',
  templateUrl: './packges.component.html',
  styleUrls: ['./packges.component.css']
})
export class PackgesComponent implements OnInit {

  nao = new Nanobar();
  packageData: any;
  packageDeleteData: any;
  PackageId: any;
  loadindData = true;
  paginatedDataPackage: any;
  packagePageCount = 0;
  packageLastPage = true;
  deleteBtndDisable = false;
  addPackgesButton = false;


  noDeliveries: any;
  price: any;
  discount: any;
  valid = '0';
  validText = '1 week / 7days';
  addDeliveryData: any;
  packageDetail: any;

  searchString = '';
  clearTimeout: any;
  filterValue = 'All';
  filterValCount = '-1';
  limit = 50;
  activeTab = 'plan';
  subscriberStatus = '-1';
  subscriberText = 'All';

  constructor(private dataService: DataService, private router: Router) { }
  getPackage() {
    this.packagePageCount = 0;
    this.packageLastPage = true;
    this.loadindData = true;
    this.nao.go(30);
    this.dataService.getDeliveryPackageslisting(window.localStorage.getItem('token'), this.searchString, this.filterValCount, this.limit).subscribe(
      (data) => {
        this.nao.go(100);
        this.packageData = data;
        this.packageLastPage = this.packageData.last_page;
        this.packagePageCount++;
        this.packageData = this.packageData.items;
        this.loadindData = false;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  filterSearch() {
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.getPackage();
    }, 1000);
  }
  clearSearch(){
    this.searchString = '';
    this.getPackage();
  }
  updateFilter(val){
    this.filterValCount = val;
    if ( this.filterValCount === '-1' ) {
      this.filterValue = 'All';
    }
    if ( this.filterValCount === '0' ) {
      this.filterValue = '1 week / 7 days';
    }
    if ( this.filterValCount === '1' ) {
      this.filterValue = '2 weeks/ 14 days';
    }
    if ( this.filterValCount === '2' ) {
      this.filterValue = '3 week / 21 days';
    }
    if ( this.filterValCount === '3' ) {
      this.filterValue = '4 week / 28 days';
    }
    this.getPackage();
  }
  getPackageDetail(id) {
    this.PackageId = id;
    this.addPackgesButton = false;
    this.nao.go(30);
    this.dataService.getDeliveryPackageslistingDetail(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.packageDetail = data;
        this.noDeliveries = this.packageDetail.no_of_deliveries;
        this.valid = this.packageDetail.validity;
        this.validText = this.packageDetail.validity_string;
        this.price = this.packageDetail.package_price;
        this.discount = this.packageDetail.off_price;
        $('#editPackagePopup').modal('show');
        $('#deliveryValidity').val(this.valid);
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getPackagelistingByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getDeliveryPackageslistingByPage(window.localStorage.getItem('token'), this.packagePageCount, this.searchString, this.filterValCount, this.limit).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataPackage = data;
        // this.limit = this.paginatedData.limit;
        this.packageLastPage = this.paginatedDataPackage.last_page;
        this.packagePageCount++;
        this.paginatedDataPackage = this.paginatedDataPackage.items;
        for (var i = 0; i < this.paginatedDataPackage.length; i++) {
          this.packageData.push(this.paginatedDataPackage[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  openDeletePackagePopup(id) {
    this.PackageId = id;
    $('#deletePackagePopup').modal('show');
  }
  deleteConform() {
    this.deleteBtndDisable = true;
    this.nao.go(30);
    this.dataService.deleteDeliveryPackageslisting(window.localStorage.getItem('token'), this.PackageId).subscribe(
      (data) => {
        this.nao.go(100);
        this.packageDeleteData = data;
        this.deleteBtndDisable = false;
        if ( this.packageDeleteData.success === true ) {
          this.getPackage();
          $('#deletePackagePopup').modal('hide');
        }
        this.getPackage();
        $('#deletePackagePopup').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  openAddPackagePopup() {
    this.noDeliveries = null;
    this.price = null;
    this.discount = null;
    this.valid = '0';
    this.validText = '1 week / 7days';
    this.addPackgesButton = false;
    $('#addPackagePopup').modal('show');
  }
  updateNoOfDelivery(value){
    this.valid = value;
    if ( value === '0' ) {
      this.validText = '1 week / 7 days';
    }
    if ( value === '1' ) {
      this.validText = '2 weeks/ 14 days';
    }
    if ( value === '2' ) {
      this.validText = '3 week / 21 days';
    }
    if ( value === '3' ) {
      this.validText = '4 week / 28 days';
    }
  }
  addDeliveryPlan() {
    if ( this.noDeliveries === null || this.noDeliveries === undefined || this.noDeliveries === '' ) {
      toastr.error('Please add No of Deliveries');
      return;
    }
    if ( this.price === null || this.price === undefined || this.price === '' ) {
      toastr.error('Please add Price');
      return;
    }
    if ( this.discount === null || this.discount === undefined || this.discount === '' ) {
      toastr.error('Please add Off price');
      return;
    }
    this.addPackgesButton = true;
    this.nao.go(30);
    this.dataService.addDeliveryPackageslisting(window.localStorage.getItem('token'), this.noDeliveries, this.valid, this.validText, this.price, this.discount).subscribe(
      (data) => {
        this.nao.go(100);
        this.addDeliveryData = data;
        this.addPackgesButton = false;
        if ( this.addDeliveryData.success === true ) {
          toastr.success('Add delivery plain Successfully');
          this.getPackage();
          $('#addPackagePopup').modal('hide');
        }
        this.getPackage();
        $('#addPackagePopup').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  editDeliveryPlan() {
    if ( this.noDeliveries === null || this.noDeliveries === undefined || this.noDeliveries === '' ) {
      toastr.error('Please add No of Deliveries');
      return;
    }
    if ( this.price === null || this.price === undefined || this.price === '' ) {
      toastr.error('Please add Price');
      return;
    }
    if ( this.discount === null || this.discount === undefined || this.discount === '' ) {
      toastr.error('Please add Off price');
      return;
    }
    this.addPackgesButton = true;
    this.nao.go(30);
    this.dataService.editDeliveryPackageslisting(window.localStorage.getItem('token'), this.noDeliveries, this.valid, this.validText, this.price, this.discount, this.PackageId).subscribe(
      (data) => {
        this.nao.go(100);
        this.addDeliveryData = data;
        this.packagePageCount = 0;
        this.packageLastPage = true;
        this.addPackgesButton = false;
        if ( this.addDeliveryData.success === true ) {
          toastr.success('Update delivery plain Successfully');
        }
        this.getPackage();
        $('#editPackagePopup').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }


  updateTabs(value){
    this.activeTab = value;
    this.filterValue = 'All';
    this.filterValCount = '-1';
    this.subscriberStatus = '-1';
    this.subscriberText = 'All';
    this.searchString = '';
    this.packagePageCount = 0;
    this.packageLastPage = true;
    if ( value === 'plan' ) {
      this.getPackage();
    }
    if ( value === 'subscribers' ) {
      this.getSubscriberList();
    }
  }

  getSubscriberList() {
    this.loadindData = true;
    this.nao.go(30);
    this.dataService.getSubscriptionSubscriberlisting(window.localStorage.getItem('token'), this.searchString, this.filterValCount, this.subscriberStatus, this.limit).subscribe(
      (data) => {
        this.nao.go(100);
        this.packageData = data;
        this.packageLastPage = this.packageData.last_page;
        this.packagePageCount++;
        this.packageData = this.packageData.items;
        this.loadindData = false;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getSubscriberListByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getSubscriptionSubscriberlistingByPage(window.localStorage.getItem('token'), this.packagePageCount, this.searchString, this.filterValCount, this.subscriberStatus, this.limit).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataPackage = data;
        // this.limit = this.paginatedData.limit;
        this.packageLastPage = this.paginatedDataPackage.last_page;
        this.packagePageCount++;
        this.paginatedDataPackage = this.paginatedDataPackage.items;
        for (var i = 0; i < this.paginatedDataPackage.length; i++) {
          this.packageData.push(this.paginatedDataPackage[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  filterSearchSubscriber() {
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.getSubscriberList();
    }, 1000);
  }
  clearSearchSucbscriber(){
    this.searchString = '';
    this.getSubscriberList();
  }
  updateFilterSubscriber(val){
    this.filterValCount = val;
    if ( this.filterValCount === '-1' ) {
      this.filterValue = 'All';
    }
    if ( this.filterValCount === '0' ) {
      this.filterValue = '1 week / 7 days';
    }
    if ( this.filterValCount === '1' ) {
      this.filterValue = '2 weeks/ 14 days';
    }
    if ( this.filterValCount === '2' ) {
      this.filterValue = '3 week / 21 days';
    }
    if ( this.filterValCount === '3' ) {
      this.filterValue = '4 week / 28 days';
    }
    this.getSubscriberList();
  }
  updateFilterSubscriberStatus(value){
    this.subscriberStatus = value;
    if ( this.subscriberStatus === '-1' ) {
      this.subscriberText = 'All';
    }
    if ( this.subscriberStatus === '0' ) {
      this.subscriberText = 'Pending';
    }
    if ( this.subscriberStatus === '1' ) {
      this.subscriberText = 'Subscribed';
    }
    if ( this.subscriberStatus === '2' ) {
      this.subscriberText = 'Rejected';
    }
    if ( this.subscriberStatus === '3' ) {
      this.subscriberText = 'Expired';
    }
    this.getSubscriberList();
  }
  openDeletePackagePopupSubscriber(id) {
    this.deleteBtndDisable = false;
    this.PackageId = id;
    $('#deleteSubscriberPopup').modal('show');
  }
  openApprovedPackagePopupSubscriber(id) {
    this.deleteBtndDisable = false;
    this.PackageId = id;
    $('#approvedSubscriberPopup').modal('show');
  }
  deleteSubscriberConform() {
    this.deleteBtndDisable = true;
    this.nao.go(30);
    this.dataService.reject_subscriptionPackages(window.localStorage.getItem('token'), this.PackageId).subscribe(
      (data) => {
        this.nao.go(100);
        this.packageDeleteData = data;
        this.deleteBtndDisable = false;
        if ( this.packageDeleteData.success === true ) {
        }
        this.getSubscriberList();
        $('#deleteSubscriberPopup').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  approvedSubscriberConform() {
    this.deleteBtndDisable = true;
    this.nao.go(30);
    this.dataService.approveSubscription(window.localStorage.getItem('token'), this.PackageId).subscribe(
      (data) => {
        this.nao.go(100);
        this.packageDeleteData = data;
        this.deleteBtndDisable = false;
        if ( this.packageDeleteData.success === true ) {
        }
        this.getSubscriberList();
        $('#approvedSubscriberPopup').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }


  ngOnInit() {
    this.getPackage();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#packges').css('color', '#d77229');
  }

}




// WEBPACK FOOTER //
// ./src/app/packges/packges.component.ts